export default function validateCreateLink(values) {
    let errors = {}

    // URL errors
    if (!values.url) {
        errors.url = "URL required"
    }

    return errors
}
